export default "__VITE_ASSET__BiABlSha__"